import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./CuppingTherapyTreatment.css";
import CupImg from "../IMG/woman-experiencing-cupping-therapy.jpg";
import BookingComponent from "../BookNow/BookNowCall";
import SEO from "../../../SEO";

const CuppingTherapyTreatment = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="cupping-page-wrapper">
      {/* Animated Header */}
      <SEO
        title="Cupping Therapy Treatment | Hijama Cupping Therapy Centre in Pune"
        description="Experience the best Cupping Therapy Treatment at Shrikrishna Arogyam in Pune. We offer you the best Hijama Cupping Therapy at an affordable price."
        keywords="Cupping Therapy Treatment , Hijama Cupping Therapy Centre in Pune"
        canonical="https://shrikrishnaarogyammassagestherapy.com/cupping-therapy-treatment"
      />
      <motion.header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2.5 }}
        className="cupping-header"
      >
        <h1>Discover Relief and Relaxation with Cupping Therapy Treatment</h1>
      </motion.header>

      <Container className="cupping-content">
        <Row className="cupping-section">
          <Col md={6} className="cupping-image-col">
            <motion.img
              src={CupImg}
              alt="Cupping Therapy"
              className="cupping-image"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
            />
          </Col>
          <Col md={6} className="cupping-text-col">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 1 }}
              className="cupping-description"
            >
              If you are feeling tired, sore, or just plain lost &amp; out of
              your usual depths, it&apos;s essential to know what the world has
              been up to, in order to counter the feeling. They&apos;ve been
              treated (and still are) by{" "}
              <b> Shrikrishna Arogyam Massage Therapy&apos;s </b>best and
              effective <b>Cupping Therapy Treatment.</b> And all it needs (for
              a start!) is one session of our gentle, effective cupping massage
              that is known to release stress and promote natural healing. It
              also boosts immunity, improves sleep patterns, and promotes mental
              clarity, thus making it not just a physical but a complete and
              holistic experience for body, mind and soul.
              <br />
              <br />
              If you&apos;re down with muscle pulls, poor blood circulation, or
              want only a detox to feel lighter, we are here for your
              well-being. Our centre serves people from all parts of Pune.
            </motion.p>
          </Col>
        </Row>

        <h2 className="hiw">What Is Cupping Therapy?</h2>
        <Card className="cupping-card">
          <Card.Body>
            <Card.Text>
              A tested way of healing in use for millennia, it uses small glass
              or silicone cups placed on the skin at specific places to create
              the feeling of a light suction. Such an action of creating a light
              suction helps in three ways: brings fresh blood to the surface,
              loosens tight muscles, and helps the body to flush out toxins.
            </Card.Text>
          </Card.Body>
        </Card>

        <h2 className="">Cupping is of two types:</h2>

        <ul>
          <li>
            <strong>Wet cupping (also called Hijama cupping) :</strong> Tiny
            cuts are made on the skin to draw out “bad blood” from deep within
            the body that is supposed to have toxins in it.
          </li>
          <li>
            <strong>Dry Cupping :</strong> Only suction action.
          </li>
        </ul>
        {/* <Row className="mb-4">
          <Col md={4}>
            <Card className="text-center WRTcard">
              <Card.Body>
                <Card.Title>Dry Cupping</Card.Title>
                <Card.Text>Only suction action. </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center WRTcard">
              <Card.Body>
                <Card.Title>
                  {" "}
                  Wet cupping (also called Hijama cupping){" "}
                </Card.Title>
                <Card.Text>
                  Tiny cuts are made on the skin to draw out “bad blood” from
                  deep within the body that is supposed to have toxins in it.{" "}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col> */}
        {/* <Col md={4}>
            <Card className="text-center WRTcard">
              <Card.Body>
                <Card.Title>Massage Cupping</Card.Title>
                <Card.Text>
                  It reduces muscle stiffness and bestows relaxation.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col> */}
        {/* </Row> */}

        <p className="muted-text">
          {" "}
          At <b>Shrikrishna Arogyam Massage Therapy</b>, both methods are done
          regularly by trained experts with utmost care being taken for safely
          and hygiene.{" "}
        </p>

        <h2>How Can It Help You?</h2>
        <p style={{ fontWeight: "bold" }}>
          Having shown immense results, <b>Cupping Therapy Treatment</b> is
          today beyond just a trend. It's in reality a powerful way to support
          the body's healing. Our clients report real results after just a few
          sessions. And from experience, we know cupping helps in the following
          ways:
        </p>

        <ul className="cupping-benefitssssssssss">
          <li>Helps greatly in reducing back and neck pain</li>
          <li>Reduces stiff muscles and related tension</li>
          <li>Helps reduce headaches and migraines</li>
          <li>Improves sleep quality</li>
          <li>Boosts blood flow and energy</li>
          <li>Reduces stress and calms the mind</li>
          <li>Supports detox and weight management</li>
          <p className="muted-text">
            You can also combine <b>cupping therapy and massage </b> for an even
            more relaxing and complete treatment.
          </p>
        </ul>

        <h2>
          Why Choose Shrikrishna Arogyam Massage Therapy for Cupping in Pune?
        </h2>
        <p style={{ fontWeight: "bold" }}>
          Because there are very few places in Pune that do cupping therapy the
          way we do. For the <b> best cupping therapy in Pune</b>, you are
          invited to experience our approach.
        </p>
        <ul className="cupping-checklist">
          <p>How we differ from the others includes:</p>
          <li>Personalized care for every case</li>
          <li>
            Extreme hygiene, be it with respect to tools or the practices
            overall
          </li>
          <li>Affordable pricing</li>
          <li>Friendly, trained staff</li>
          <li>Calm and hygienic atmosphere</li>
          <li>Therapy based on your body&apos;s unique needs</li>
        </ul>

        <p className="muted-text">
          We're trusted by people from{" "}
          <b> Kothrud, Baner, Balewadi, Aundh, and Panchvati </b>— and once you
          visit us, you'll understand why.
        </p>

        <h2>More About Hijama Cupping Therapy </h2>
        <p style={{ fontWeight: "bold" }}>
          You may have heard about <b> Hijama Therapy.</b> It's a specific type
          of wet cupping treatment where tiny cuts are made on the skin and the
          suction removes impure blood. Many believe this can clear blockages
          and boost energy levels.
        </p>
        <ul className="cupping-checklist">
          <p>It's often used to help with:</p>
          <li>Body pain that doesn't go away</li>
          <li>Headaches or migraines</li>
          <li>Skin problems</li>
          <li>Chronic fatigue</li>
          <li>Hormonal issues</li>
        </ul>

        <p className="muted-text">
          At our body massage centre, <b>Cupping Therapy Treatment</b> is done
          by experienced professionals in a calm, respectful, and fully hygienic
          environment.
        </p>

        <h2>Is Cupping Right for You? </h2>
        <p>
          Cupping can help a wide range of people. You might want to try it if:
        </p>
        <ul className="cupping-checklist">
          <li>You sit for long hours and feel stiff or sore</li>
          <li>You've had pain that doesn't improve with regular massage</li>
          <li>You want to detox naturally</li>
          <li>You're an athlete or gym-goer and need muscle recovery</li>
          <li>
            You're simply looking for a new way to feel better, inside and out
          </li>
        </ul>

        <p className="muted-text">
          Many people from the Pune area have felt the difference cupping can
          make — and so can you.
        </p>

        <h2>Ready to Try It?</h2>
        <p>
          <span style={{ display: "block" }}>
            Your body speaks to you — sometimes through pain, stiffness, or just
            a sense that something's off.<b> Cupping Therapy Treatment</b> can be a
            gentle step toward feeling like yourself again.
          </span>
          <br />{" "}
          <span style={{ display: "block" }}>
            Book a session with <b>Shrikrishna Arogyam</b> today. Whether it's your
            first time or you've tried cupping before, we'll make sure you feel
            cared for every step of the way. From Hijama to cupping therapy and
            <b> full body massage</b>, we offer a natural path to relief.
          </span>
          <br />
          <span style={{ display: "block" }}>
            {" "}
            We proudly serve clients across Kothrud, Karve Nagar, Deccan, Baner,
            Balewadi, Aundh, Panchvati, Wakad, Hinjewadi, Pimple Nilakh,
            Tathawade, Mahalunge, Sus, Pashan, Punawale, and PCMC — and we'd
            love to welcome you too.
          </span>
        </p>

        <BookingComponent />
      </Container>
    </div>
  );
};

export default CuppingTherapyTreatment;
